import Vue from "vue";
const vue = new Vue();

export const eventBus = {
  subscribe(event, handler) {
    return vue.$on(event, handler);
  },

  send(event, data) {
    return vue.$emit(event, data);
  }
};